import { render, staticRenderFns } from "./TgSpecialCardGroup.vue?vue&type=template&id=80ee4894&"
import script from "./TgSpecialCardGroup.vue?vue&type=script&lang=js&"
export * from "./TgSpecialCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports